import {
  MODELS_LIST_PAGE_SIZES,
  type ModelsListPageSize,
} from "./useManufacturingModelsListPagination";

type Props = {
  page: number;
  pageCount: number;
  pageSize: ModelsListPageSize;
  rangeStart: number;
  rangeEnd: number;
  total: number;
  canPrev: boolean;
  canNext: boolean;
  onSetPage: (next: number) => void;
  onSetPageSize: (next: ModelsListPageSize) => void;
  variant: "top" | "bottom";
  alwaysShow?: boolean;
};

export function ManufacturingModelsRecipeListPagination(props: Props) {
  if (!props.alwaysShow && props.total <= props.pageSize) return null;
  const wrapClass =
    props.variant === "bottom"
      ? "flex flex-wrap items-center justify-between gap-2 border-t border-gray-100 pt-2 dark:border-zinc-700"
      : "flex flex-wrap items-center justify-between gap-2";
  return (
    <div className={wrapClass}>
      <p className="text-[11px] text-gray-600 dark:text-zinc-400">
        Showing{" "}
        <span className="tabular-nums font-medium text-gray-800 dark:text-zinc-200">
          {props.rangeStart}
        </span>
        –
        <span className="tabular-nums font-medium text-gray-800 dark:text-zinc-200">
          {props.rangeEnd}
        </span>{" "}
        of{" "}
        <span className="tabular-nums font-medium text-gray-800 dark:text-zinc-200">
          {props.total}
        </span>
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <label className="flex items-center gap-1 text-[11px] text-gray-600 dark:text-zinc-400">
          Per page
          <select
            className="rounded-md border border-gray-200 bg-white px-1.5 py-0.5 text-xs text-gray-900 dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-100"
            value={props.pageSize}
            onChange={(e) => props.onSetPageSize(Number(e.target.value) as ModelsListPageSize)}
          >
            {MODELS_LIST_PAGE_SIZES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </label>
        <div className="flex items-center gap-1">
          <button
            type="button"
            disabled={!props.canPrev}
            onClick={() => props.onSetPage(props.page - 1)}
            className="rounded-md border border-gray-200 bg-white px-2 py-0.5 text-[11px] font-medium text-gray-800 disabled:opacity-40 dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-100"
          >
            Prev
          </button>
          <span className="px-1 text-[11px] tabular-nums text-gray-600 dark:text-zinc-400">
            {props.page + 1} / {props.pageCount}
          </span>
          <button
            type="button"
            disabled={!props.canNext}
            onClick={() => props.onSetPage(props.page + 1)}
            className="rounded-md border border-gray-200 bg-white px-2 py-0.5 text-[11px] font-medium text-gray-800 disabled:opacity-40 dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-100"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
